import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { environment } from '../../environments/environment';
import { DataService } from './data.service';
import { MessageNotificationResponse } from '../interface/chat.interface';
import { Store } from '@ngrx/store';
import { Socket } from 'ngx-socket-io';

@Injectable()
export class ChatV2Service extends DataService {
  socket: Socket;

  constructor(private http: HttpClient, protected injector: Injector, protected store: Store<any>) {
    super(injector, store);
  }

  connect() {
    try {
      const user = this.getUser();
      const building = this.getBuilding();
      
      if (!user || !user.token) {
        console.error('No user token available for socket connection');
        return;
      }
      
      if (!building || (!building._id && !building.id)) {
        console.error('No building available for socket connection');
        return;
      }

      this.socket = new Socket({
        url: environment.socketUrl + '/chat',
        options: {
          query: {
            authorization: user.token,
            building: building._id || building.id,
          },
          transports: ['websocket'],
          timeout: 20000,
          autoConnect: true,
          path: '/socket.io/',
          reconnection: true,
          reconnectionAttempts: 5,
          reconnectionDelay: 1000,
          reconnectionDelayMax: 5000,
          upgrade: false,
          rememberUpgrade: false
        }
      });

			this.socket.on('connect_error', (_error: any) => {
				if (_error?.message && _error.message.includes('v2.x with a v3.x client')) {
					this.connectWithV2Config();
				}
			});
		} catch (_error) {
      console.error('Error al conectar con el socket:', _error);
    }
  }

  private connectWithV2Config(): void {
    try {
      const user = this.getUser();
      const building = this.getBuilding();
      
      if (this.socket) {
        this.socket.disconnect();
      }

      this.socket = new Socket({
        url: environment.socketUrl + '/chat',
        options: {
          query: {
            authorization: user.token,
            building: building._id || building.id,
          },
          transports: ['websocket'],
          timeout: 30000,
          autoConnect: true,
          path: '/socket.io/',
          reconnection: true,
          reconnectionAttempts: 5,
          reconnectionDelay: 1000,
          reconnectionDelayMax: 5000,
          upgrade: false,
          rememberUpgrade: false
        }
      });
    } catch (_error) {
      console.error('Error al conectar con el socket:', _error);
    }
  }

  disconnect() {
    if (this.socket) {
      this.socket.removeAllListeners();
      this.socket.disconnect();
    }
  }

  getEnableChats(data: any) {
    let params = new HttpParams().append('page', data.page).append('size', data.size);
    return this.http.get<any>('/api/admin/v1/chat/enable-chats-paginated',{ params: params });
  }

  getMessagePaginated(data: any) {
    let params = new HttpParams().append('page', data.page).append('size', data.size);

    return this.http.get<any>(`/api/admin/v1/chat/messages/${data.roomId}`, { params: params });
  }

  getAvaliableClass(search?: string) {
    let params = new HttpParams();
    if (search) params = params.append('search', '' + search);
    return this.http.get<any>('/api/admin/v1/chat/available-chats', { params: params });
  }

  uploadAttachment(file: FormData, room:string) {
    return this.http.post(`/api/admin/v1/chat/${room}/attachment`, file);
  }

  sentMessageActionResponse(buildingId:string, payload:MessageNotificationResponse){
    return this.http.put(`/api/admin/v1/chat/action-message`, payload);
  }

  getRoomWith(userId: string) {
    return this.http.get(`${environment.apiUrl}/admin/v1/chat/user/${userId}`);
  }
}
